export enum CertificateType {
    medical = 1,
    sickness = 2
}

const CERTIFICATE_TYPE_TRANSLATION_KEYS: Record<CertificateType, string> = {
    [CertificateType.medical]: 'medical_certificate',
    [CertificateType.sickness]: 'sickness_certificate'
};

export function getCertificateTypeText(type: CertificateType): string {
    return CERTIFICATE_TYPE_TRANSLATION_KEYS[type] ?? '';
}

const CERTIFICATE_TYPE_HISTORY_TRANSLATION_KEYS: Record<CertificateType, string> = {
    [CertificateType.medical]: 'medical_certificate_history',
    [CertificateType.sickness]: 'sickness_certificate_history'
};

export function getCertificateTypeHistoryText(type: CertificateType): string {
    return CERTIFICATE_TYPE_HISTORY_TRANSLATION_KEYS[type] ?? '';
}
